var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoingecko(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF00;}\r\n\t.st1{display:none;fill:url(#SVGID_1_);}\r\n\t.st2{display:none;fill:url(#SVGID_2_);}\r\n\t.st3{display:none;fill:url(#SVGID_3_);}\r\n\t.st4{display:none;}\r\n\t.st5{display:inline;fill:url(#SVGID_4_);}\r\n\t.st6{display:none;fill:url(#SVGID_5_);}\r\n\t.st7{display:none;fill:url(#SVGID_6_);}\r\n\t.st8{display:inline;fill:url(#SVGID_7_);}\r\n\t.st9{display:inline;fill:url(#SVGID_8_);}\r\n\t.st10{display:inline;fill:url(#SVGID_9_);}\r\n\t.st11{display:inline;fill:url(#SVGID_10_);}\r\n\t.st12{display:inline;fill:url(#SVGID_11_);}\r\n\t.st13{display:inline;fill:url(#SVGID_12_);}\r\n\t.st14{display:inline;fill:url(#SVGID_13_);}\r\n\t.st15{fill:none;stroke:url(#SVGID_14_);stroke-miterlimit:10;}\r\n\t.st16{fill:#eee;stroke:url(#SVGID_15_);stroke-miterlimit:10;}\r\n\t.st17{fill:#fff;}\r\n\t.st18{fill:#000;}\r\n\t.st19{fill:#eee;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84,480h328c19.9,0,36-16.1,36-36l0,0c0-19.9-16.1-36-36-36h-3.1c-8,0-15.4-5.4-16.6-13.3 c-1.6-10,6.1-18.7,15.8-18.7h42.3c18.8,0,35.6-13.6,37.5-32.3C490,322.3,473,304,452,304h-27.1c-8,0-15.4-5.4-16.6-13.3 c-1.6-10,6.1-18.7,15.8-18.7h41.9c22.9,0,43.5-16.7,45.8-39.5c2.6-26.2-18.1-48.5-43.8-48.5h-98.6c-13,0-24.6-9.7-25.3-22.7 c-0.7-13.8,10.3-25.3,24-25.3h17.9c22.9,0,43.5-16.7,45.8-39.5C434.4,70.3,413.7,48,388,48H84c-24.3,0-44,19.7-44,44l0,0 c0,24.3,19.7,44,44,44h28c8.8,0,16,7.2,16,16l0,0c0,8.8-7.2,16-16,16H37.7c-18.8,0-35.6,13.6-37.5,32.3C-2,221.7,15,240,36,240h66.6 c13,0,24.6,9.7,25.3,22.7c0.7,13.8-10.3,25.3-24,25.3H61.7c-18.8,0-35.6,13.6-37.5,32.3C22,341.7,39,360,60,360h51.1 c8,0,15.4,5.4,16.6,13.3c1.6,10-6.1,18.7-15.8,18.7H84c-24.3,0-44,19.7-44,44l0,0C40,460.3,59.7,480,84,480z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -10.3749,
    y1: 571.523,
    x2: -10.3749,
    y2: 613.523,
    gradientTransform: "matrix(8 0 0 -8 343 5085)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eee"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.3,152.5c-11.5,3.9-24,6.2-37.1,7.6c12.9-6.4,21.9-15.9,30.2-27.5c4.8-6.6-2.6-15.3-10-11.8 c-13.1,6.3-25.8,11.1-41.7,13.8c-15.6-14-36.2-22.6-58.8-22.6c-32.9,0-61.5,18-76.6,44.6c-7.3,12.8-11.4,27.6-11.4,43.4 c0,5.4,0.7,10.7,1.6,15.8c-70.7-2.1-130-38.6-163.7-84.5c-3.7-5.1-11.6-4-13.9,1.9c-3.6,9-8,18.9-8,34.9c0,1,0,1.8,0.1,2.7 c0.3,10.4,2.6,20.3,6.6,29.3c7.5,17.4,21.1,31.5,38.2,39.8c-1.6,0.1-3.2,0.2-4.9,0.2c-16,0-21.3-5.5-29.9-7.7 c-5.5-1.4-10.8,3.1-10,8.7c2.6,17.8,11.9,36.5,24.2,48.4c13.3,13,31,21.3,50.8,22.5c-10.6,5.2-22.5,8.2-35.1,8.2h-8 c-6,0-9.8,6.4-7.1,11.8c13.4,26.5,44.5,44.2,77.8,44.1C142.6,396.1,104.7,408,64,408h-8c-4.4,0-8,3.6-8,8c0,3.7,2.5,6.6,5.9,7.6 l0,0.1c0,0,60.2,24.3,130.1,24.3c135.4,0,245.5-108.6,247.9-243.4c0.1-1.5,0.1-3,0.1-4.6s0-3-0.1-4.6c-0.1-2.2-0.4-4.4-0.7-6.5 c14.8-4.7,28-12.5,38.5-23.4C475.5,159.5,469.2,149.8,461.3,152.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.0007,
    y1: 264,
    x2: 466.0006,
    y2: 264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eee"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M432.5,136.8l33.5-32.1v-7H349.9l-82.7,205.9L173,97.7H51.3v7l39.1,47.1c3.8,3.5,5.8,8.6,5.3,13.7v185.2 c1.2,6.7-1,13.5-5.7,18.4L46,422.6v6.9h125v-7l-44.1-53.4c-4.8-4.9-7-11.6-6.1-18.4V190.6l109.8,239h12.8l94.4-239V381 c0,5,0,6.1-3.3,9.3l-34,32.8v7h164.7v-7l-32.7-32c-2.9-2.2-4.4-5.8-3.7-9.3V146.2C428.1,142.6,429.6,139,432.5,136.8L432.5,136.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.1944,
    y1: 256.9907,
    x2: 467,
    y2: 256.9907
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eee"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M420,209.7c-13.3,0-25,5.6-33.7,14.3c-31.7-22.3-74.5-36.6-121.9-38.2L289,73.3l78.4,17.9 c0,19.5,15.6,35.4,34.8,35.4c19.6,0,35.3-16.3,35.3-35.8s-15.6-35.8-35.3-35.8c-13.7,0-25.5,8.4-31.4,19.8l-86.6-19.5 c-4.4-1.2-8.6,2-9.8,6.4l-27,124.1c-47,2-89.4,16.3-121.2,38.6c-8.6-9.1-20.8-14.7-34.1-14.7c-49.4,0-65.6,67.3-20.4,90.3 c-1.6,7.1-2.3,14.7-2.3,22.3c0,75.6,83.9,136.8,187,136.8c103.5,0,187.4-61.2,187.4-136.8c0-7.6-0.8-15.5-2.7-22.7 C485.5,276.5,469.1,209.7,420,209.7L420,209.7z M143.6,304.8c0-19.8,15.6-35.8,35.3-35.8c19.2,0,34.9,15.9,34.9,35.8 c0,19.5-15.6,35.4-34.9,35.4C159.4,340.2,143.6,324.3,143.6,304.8L143.6,304.8z M334.1,389.1c-32.4,32.8-123.7,32.8-156,0 c-3.6-3.2-3.6-8.8,0-12.4c3.1-3.2,8.6-3.2,11.7,0c24.7,25.7,106.7,26.2,132.5,0c3.1-3.2,8.6-3.2,11.7,0 C337.7,380.4,337.7,385.9,334.1,389.1L334.1,389.1z M333.4,340.2c-19.2,0-34.8-15.9-34.8-35.3c0-19.8,15.6-35.8,34.8-35.8 c19.6,0,35.3,15.9,35.3,35.8C368.6,324.3,353,340.2,333.4,340.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.3329,
    y1: 256.4818,
    x2: 462,
    y2: 256.4818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eee"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M398.5,125c-26.4-12.1-54.6-21-84.2-26.1c-0.5-0.1-1.1,0.1-1.4,0.6c-3.6,6.5-7.7,14.9-10.5,21.5 c-31.8-4.8-63.4-4.8-94.6,0c-2.8-6.8-7-15.1-10.6-21.5c-0.3-0.5-0.8-0.7-1.4-0.6c-29.5,5.1-57.8,14-84.2,26.1 c-0.2,0.1-0.4,0.3-0.6,0.5C57.5,205.6,42.8,283.7,50,360.9c0,0.4,0.2,0.7,0.5,1c35.4,26,69.7,41.8,103.3,52.2 c0.5,0.2,1.1,0,1.5-0.5c8-10.9,15-22.3,21.1-34.4c0.4-0.7,0-1.5-0.7-1.8c-11.3-4.3-22-9.5-32.3-15.4c-0.8-0.5-0.9-1.6-0.1-2.2 c2.2-1.6,4.3-3.3,6.4-5c0.4-0.3,0.9-0.4,1.3-0.2c67.7,30.9,141,30.9,207.9,0c0.4-0.2,1-0.1,1.4,0.2c2.1,1.7,4.2,3.4,6.4,5 c0.7,0.6,0.7,1.7-0.1,2.2c-10.3,6-21,11.1-32.3,15.4c-0.7,0.3-1.1,1.1-0.7,1.8c6.2,12,13.3,23.5,21.1,34.4c0.3,0.5,0.9,0.7,1.5,0.5 c33.8-10.5,68.1-26.2,103.5-52.2c0.3-0.2,0.5-0.6,0.5-1c8.6-89.2-14.4-166.7-61.2-235.5C398.9,125.2,398.7,125.1,398.5,125z  M186.6,313.9c-20.4,0-37.2-18.7-37.2-41.7s16.5-41.7,37.2-41.7c20.9,0,37.5,18.9,37.2,41.7C223.7,295.2,207.3,313.9,186.6,313.9z  M324,313.9c-20.4,0-37.2-18.7-37.2-41.7s16.5-41.7,37.2-41.7c20.9,0,37.5,18.9,37.2,41.7C361.2,295.2,344.9,313.9,324,313.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.0718,
    y1: 256.5,
    x2: 466.4041,
    y2: 256.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eee"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M457.7,155.2c-4.9-18.1-19.1-32.3-37.1-37.1c-33-9-164.9-9-164.9-9s-131.9,0-164.9,8.7 c-17.7,4.9-32.3,19.4-37.1,37.5c-8.7,33-8.7,101.3-8.7,101.3s0,68.7,8.7,101.3c4.9,18,19.1,32.3,37.1,37.1c33.3,9,164.9,9,164.9,9 s131.9,0,164.9-8.7c18.1-4.9,32.3-19.1,37.1-37.1c8.7-33,8.7-101.3,8.7-101.3S466.7,188.1,457.7,155.2z M213.7,319.7V193.3 l109.7,63.2L213.7,319.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.8361,
    y1: 264,
    x2: 431,
    y2: 264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eee"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M190.3,316.5l-6.6,92.2c9.4,0,13.4-4,18.3-8.9l44-42l91.1,66.7c16.7,9.3,28.5,4.4,33-15.4L429.9,129l0,0 c5.3-24.7-8.9-34.4-25.2-28.3L53.2,235.2c-24,9.3-23.6,22.7-4.1,28.7l89.8,27.9l208.7-130.6c9.8-6.5,18.8-2.9,11.4,3.6L190.3,316.5z "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.1085,
    y1: 296.7071,
    x2: 197.6251,
    y2: 296.7071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eee"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M197.6,330.2l-58-100.5l-44.5,25.7c-27.7,16.1-37.2,51.5-21.2,79.3c16,27.7,51.5,37.2,79.2,21.2L197.6,330.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.3434,
    y1: 135.2174,
    x2: 458.0622,
    y2: 135.2174
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eee"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M392.2,154c1.3,2.1,3.4,3.3,5.8,3.3c1.1,0,2.2-0.3,3.3-0.9l53.4-30.9c3.2-1.9,4.2-5.9,2.4-9.1 c-1.9-3.2-5.9-4.2-9.1-2.4l-53.4,30.9C391.5,146.8,390.4,150.8,392.2,154L392.2,154z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.1095,
    y1: 206.7274,
    x2: 483,
    y2: 206.7274
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eee"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M476.1,198.8l-61.7,2.7c-3.6,0.1-6.5,3.2-6.4,6.9c0.1,3.6,3.1,6.4,6.6,6.4h0.3l61.7-2.7 c3.6-0.1,6.5-3.2,6.4-6.9C482.9,201.4,479.8,198.7,476.1,198.8L476.1,198.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.0441,
    y1: 81.4466,
    x2: 396.4618,
    y2: 81.4466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eee"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M353.1,113c1.1,0.7,2.3,1.1,3.6,1.1c2.2,0,4.3-1.1,5.6-3L395.4,59c2-3.1,1.1-7.1-2-9.1 c-3.1-2-7.1-1.1-9.1,2.1L351.1,104C349.1,107,350,111,353.1,113z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.7714,
    y1: 404.9962,
    x2: 238.031,
    y2: 404.9962
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eee"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M195.3,346.8l-35.6,20.6c-4.8,2.7-9.8,4.8-14.9,6.4c6.4,31.6,22.6,60.5,46.3,82.3c8.9,8.1,22,9.5,32.3,3.4 c0.3-0.1,0.5-0.3,0.7-0.4c15.1-8.7,18.6-29.2,6.9-42.2C213.3,397.1,200.9,372.9,195.3,346.8L195.3,346.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.9311,
    y1: 202.7953,
    x2: 380.6617,
    y2: 202.7953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eee"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M283.8,213.4c-21.6-37.4-39-74.3-49.1-104c-5.8-17-8.9-30.5-9.3-40.9c-13.6,17.9-20.5,47.2-29.8,72.5 c-10.9,34.2-25.9,61.3-45.7,80l60.4,104.6c26.1-7.8,57.2-7.2,92.2,0.4c26.7,4.6,55.8,13.4,78.1,10.4 C341.8,312.5,290.4,224.8,283.8,213.4L283.8,213.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.6163,
    y1: 191.1826,
    x2: 406.1577,
    y2: 191.1826
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eee"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M243.1,54c-12.2,7.1,1.2,54.2,30.4,112.6c21.1-9.9,46.6-2.2,58.5,18.3c11.9,20.6,5.8,46.6-13.4,59.9 c36.3,55.1,70.7,90.8,83,83.7c14.9-8.7-8.3-77.1-52.1-152.9S258.2,45.3,243.1,54L243.1,54z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.3716,
    y1: 256,
    x2: 459.7299,
    y2: 256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eee"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M459.2,255.1c0.3,81-48,154.3-122.7,185.6s-160.8,14.6-218.4-42.4c-57.6-57.1-75-143.1-44.4-218.1 c30.5-75,103.5-124,184.3-124.5C368.8,55.4,458.7,144.6,459.2,255.1L459.2,255.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.8,70.6c12.7-2.2,25.4-2.2,38.1,0c12.7,1.9,25.2,6.2,36.5,12.2c11.4,6.2,21.1,14.6,30.8,22.4 c9.7,7.8,19.5,16,28.7,24.9c9.5,8.7,17.6,18.7,24.3,29.5c7,10.8,12.7,22.4,17,34.3c8.4,24.3,11.1,50.6,7,75.5H444 c-4.1-24.9-9.7-48.4-18.7-70.9c-4.1-11.4-9.2-22.4-14.6-33c-6-10.5-12.2-21.1-19.2-30.8c-7-10-16-18.9-26-26.2 c-10-7.3-21.6-11.9-32.7-16.2c-11.1-4.3-22.4-8.9-34.1-12.4c-11.6-3.2-23.5-6-36-8.4V70.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.5427,
    y1: 300.686,
    x2: 418.761,
    y2: 300.686
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#eee"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M359.6,185c-14.3-4.1-29.2-10-44.4-16c-0.8-3.8-4.3-8.4-11.1-14.3c-9.7-8.7-28.4-8.4-44.4-4.6 c-17.6-4.1-35.2-5.7-51.9-1.6C70.8,186.4,148.4,278.3,98.1,371.1c7,15.1,84.4,103.9,196.1,80.1c0,0-38.1-91.7,48.1-135.8 C412.4,279.7,462.7,213.2,359.6,185L359.6,185z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M259.8,150.1c10,0.8,46.2,12.4,55.4,18.9C307.4,146.6,281.5,143.7,259.8,150.1L259.8,150.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.7,245.3c0,7.3-8.9,11.1-14.1,6c-5.1-5.1-1.6-14.1,5.7-14.3C372.9,237.2,376.7,240.7,376.7,245.3 L376.7,245.3z M269.3,207.2c0,15.4-9.5,29.5-23.8,35.4c-14.3,6-30.8,2.7-41.9-8.4c-11.1-11.1-14.3-27.6-8.4-41.9 c6-14.3,20-23.8,35.4-23.8c10.3,0,20,4.1,27,11.1C265.2,187.2,269.3,196.9,269.3,207.2L269.3,207.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M257.9,207.5c0,10.8-6.5,20.8-16.8,24.9c-10,4.1-21.6,1.9-29.5-6c-7.8-7.8-10-19.2-6-29.5 c4.1-10,14.1-16.8,24.9-16.8C245.8,180.4,257.9,192.6,257.9,207.5L257.9,207.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M407.8,262.4c-31.1,21.9-66.5,38.4-116.6,38.4c-23.5,0-28.1-24.9-43.8-12.7c-8.1,6.2-36.2,20.3-58.7,19.5 c-22.4-1.1-58.7-14.3-68.7-61.9c-4.1,47.9-6,83-24.1,123.3c35.7,57.3,120.9,101.4,198.2,82.5c-8.4-58.1,42.5-114.9,70.9-143.9 C376.1,296.2,397,278.3,407.8,262.4L407.8,262.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M406.4,263.7c-9.7,8.9-21.1,15.4-32.7,21.1c-11.9,5.7-24.1,10-36.8,13.5c-12.7,3.2-26,5.7-39.2,4.6 c-13.5-1.1-27-5.7-36-15.7l0.5-0.5c10.8,7,23.5,9.5,36,10c12.7,0.3,25.4-0.5,37.9-3c12.4-2.7,24.9-6.5,36.8-11.4 c11.9-4.9,23.5-10.5,33.8-18.7H406.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoingecko);
export default __webpack_public_path__ + "static/media/coingecko.1078f93caa86380797d05960249ea189.svg";
export { ForwardRef as ReactComponent };